const state = {
  isModalOpen: false,
  modalTitle: '',
  modalMessage: '',
  modalType: 'default', // 'default', 'locked_point', or 'inventory_change'
  modalData: null // Additional data for the modal
}

const mutations = {
  SET_MODAL_OPEN(state, isOpen) {
    state.isModalOpen = isOpen
  },
  SET_MODAL_CONTENT(state, { title, message, type = 'default', data = null }) {
    state.modalTitle = title
    state.modalMessage = message
    state.modalType = type
    state.modalData = data
  }
}

const actions = {
  openModal({ commit }, { title, message, type = 'default', data = null }) {
    commit('SET_MODAL_CONTENT', { title, message, type, data })
    commit('SET_MODAL_OPEN', true)
  },
  closeModal({ commit }) {
    commit('SET_MODAL_OPEN', false)
  }
}

const getters = {
  isModalOpen: state => state.isModalOpen,
  modalTitle: state => state.modalTitle,
  modalMessage: state => state.modalMessage,
  modalType: state => state.modalType,
  modalData: state => state.modalData
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 